/** ISO region + E.164 dial code for review contact phone input. */
export type PhoneCountryOption = {
  region: string;
  dialCode: string;
  label: string;
};

/** Common App Store markets; sorted by label for the select UI. */
export const PHONE_COUNTRY_OPTIONS: PhoneCountryOption[] = [
  { region: 'AU', dialCode: '+61', label: 'Australia' },
  { region: 'AT', dialCode: '+43', label: 'Austria' },
  { region: 'BE', dialCode: '+32', label: 'Belgium' },
  { region: 'BR', dialCode: '+55', label: 'Brazil' },
  { region: 'CA', dialCode: '+1', label: 'Canada' },
  { region: 'CN', dialCode: '+86', label: 'China' },
  { region: 'HR', dialCode: '+385', label: 'Croatia' },
  { region: 'CZ', dialCode: '+420', label: 'Czechia' },
  { region: 'DK', dialCode: '+45', label: 'Denmark' },
  { region: 'EG', dialCode: '+20', label: 'Egypt' },
  { region: 'FI', dialCode: '+358', label: 'Finland' },
  { region: 'FR', dialCode: '+33', label: 'France' },
  { region: 'DE', dialCode: '+49', label: 'Germany' },
  { region: 'GR', dialCode: '+30', label: 'Greece' },
  { region: 'HK', dialCode: '+852', label: 'Hong Kong' },
  { region: 'HU', dialCode: '+36', label: 'Hungary' },
  { region: 'IN', dialCode: '+91', label: 'India' },
  { region: 'ID', dialCode: '+62', label: 'Indonesia' },
  { region: 'IE', dialCode: '+353', label: 'Ireland' },
  { region: 'IL', dialCode: '+972', label: 'Israel' },
  { region: 'IT', dialCode: '+39', label: 'Italy' },
  { region: 'JP', dialCode: '+81', label: 'Japan' },
  { region: 'KR', dialCode: '+82', label: 'South Korea' },
  { region: 'MY', dialCode: '+60', label: 'Malaysia' },
  { region: 'MX', dialCode: '+52', label: 'Mexico' },
  { region: 'NL', dialCode: '+31', label: 'Netherlands' },
  { region: 'NZ', dialCode: '+64', label: 'New Zealand' },
  { region: 'NO', dialCode: '+47', label: 'Norway' },
  { region: 'PL', dialCode: '+48', label: 'Poland' },
  { region: 'PT', dialCode: '+351', label: 'Portugal' },
  { region: 'RO', dialCode: '+40', label: 'Romania' },
  { region: 'RU', dialCode: '+7', label: 'Russia' },
  { region: 'SA', dialCode: '+966', label: 'Saudi Arabia' },
  { region: 'SG', dialCode: '+65', label: 'Singapore' },
  { region: 'SK', dialCode: '+421', label: 'Slovakia' },
  { region: 'ES', dialCode: '+34', label: 'Spain' },
  { region: 'SE', dialCode: '+46', label: 'Sweden' },
  { region: 'CH', dialCode: '+41', label: 'Switzerland' },
  { region: 'TW', dialCode: '+886', label: 'Taiwan' },
  { region: 'TH', dialCode: '+66', label: 'Thailand' },
  { region: 'TR', dialCode: '+90', label: 'Türkiye' },
  { region: 'UA', dialCode: '+380', label: 'Ukraine' },
  { region: 'AE', dialCode: '+971', label: 'United Arab Emirates' },
  { region: 'GB', dialCode: '+44', label: 'United Kingdom' },
  { region: 'US', dialCode: '+1', label: 'United States' },
  { region: 'VN', dialCode: '+84', label: 'Vietnam' },
].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

/** Dial codes longest-first for parsing stored E.164 numbers. */
export const PHONE_DIAL_CODES_DESC = Array.from(
  new Set(PHONE_COUNTRY_OPTIONS.map(c => c.dialCode))
).sort((a, b) => b.length - a.length);

export function dialCodeForRegion(region: string): string {
  const upper = region.toUpperCase();
  return PHONE_COUNTRY_OPTIONS.find(c => c.region === upper)?.dialCode ?? '+1';
}

export function regionForDialCode(dialCode: string): string {
  return PHONE_COUNTRY_OPTIONS.find(c => c.dialCode === dialCode)?.region ?? 'US';
}
